import type { AdminLookupUser } from '../api/admin.api'

type UserSource = {
  email?: string
  name?: string
}
type AdminUserDisplayInput = {
  userId?: string | null
  user?: UserSource | null
  usersById?: ReadonlyMap<string, AdminLookupUser>
  isLoading?: boolean
}

export type AdminUserDisplay = {
  primary: string
  secondary?: string
  title?: string
  resolved: boolean
}

export function adminUserDisplay({
  userId,
  user,
  usersById,
  isLoading = false,
}: AdminUserDisplayInput): AdminUserDisplay {
  const resolved = user?.email ? user : userId ? usersById?.get(userId) : undefined

  if (resolved?.email) {
    return {
      primary: resolved.email,
      secondary: resolved.name,
      title: resolved.email,
      resolved: true,
    }
  }

  if (userId && isLoading) {
    return {
      primary: 'Buscando e-mail...',
      resolved: false,
    }
  }

  if (userId) {
    return {
      primary: 'E-mail não localizado',
      secondary: 'Usuário sem e-mail retornado pela API',
      resolved: false,
    }
  }

  return {
    primary: 'VENDEPAY',
    resolved: true,
  }
}
